<template>
	<div id="account-navigation">
		<p class="active" @click="changeTab" data-id="1">Account</p>
    <p id="feedback-d" @click="changeTab" data-id="2">Feedback</p>
    <p @click="changeTab" data-id="3" v-if="currentUser.tier=='FREE'">Upgrade Plan</p>
	</div>
</template>

<script>
import {axiosClient} from "@/axios-client";
import router from '@/router/index.js';

export default {
  name: 'navigation',
  props: ['data'],
  created() {
    axiosClient.get('v1/account')
      .then((response) => {
        this.currentUser = response.data
    })
  },
  mounted(){
    if(this.$route.query.data == 'feedback'){

      let navItems = document.querySelectorAll('#account-navigation p');
      console.log(navItems)
      for(let i of navItems) {
        i.classList.remove('active');
      }

      let mainItem = document.querySelectorAll('.account-tab-item-acc-d');
      this.hide(mainItem);

      let el = document.querySelector('#feedback-d');
      el.classList.add('active');
      document.querySelector('.account-tab-item-feed-d').style.display= 'block';
      el.classList.style.visibility = "initial";

      console.log("done")
    }
  },
  data() {
    return {
      currentUser: {}
    }
  },
  methods: {
    hide (elements) {
      elements = elements.length ? elements : [elements];
      for (var index = 0; index < elements.length; index++) {
        elements[index].style.display = 'none';
      }
    },
    changeTab(e) {
      let items = document.querySelectorAll('#account-navigation p');

      for(let i of items) {
        i.classList.remove('active');
      }
      e.target.classList.add('active');
      let id = e.target.getAttribute('data-id');
      // if(id == "2"){
      //   let routeData = this.$router.resolve({name: 'account', query: {data: "feedback"}});
      //   window.open(routeData.href, '_blank');
      // }

      this.$emit('click', e.target);
    }
  }
}
</script>

<style lang="scss">
	#account-navigation {
    width: 250px;
    box-shadow: 0px 4px 15px rgba(51, 51, 51, 0.03);
    border-radius: 15px;
    background: #fff;
    padding: 44px 0;

    p {
      margin: 0;
      padding: 30px 50px;
      border-left: 5px solid transparent;
      cursor: pointer;

      &.active {
        background: #f9f9f9;
        border-left: 5px solid #FCAF05;
      }
    }
  }
</style>